import React, { useState } from 'react';
import { Download, Mail } from 'lucide-react';
import Button from './ui/Button';
import Modal from './ui/Modal';

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/documents/CV-Wimboro.pdf';
    link.download = 'CV-Wimboro.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setIsModalOpen(false);
  };

  return (
    <>
      <section
        id="hero"
        className="relative overflow-hidden scroll-mt-20 pt-24 md:pt-28"
      >
        <div className="bg-grid-fade pointer-events-none absolute inset-0" aria-hidden="true" />
        <div
          className="pointer-events-none absolute right-0 top-24 h-72 w-72 rounded-full bg-btc-orange opacity-10 blur-[120px]"
          aria-hidden="true"
        />

        <div className="container-max section-padding relative grid items-center gap-12 py-12 lg:grid-cols-12 lg:py-20">
          <div className="lg:col-span-7">
            <p className="label mb-6">01. Profile</p>
            <h1 className="font-heading text-5xl font-bold leading-tight tracking-tight sm:text-6xl md:text-7xl">
              Wimboro
              <br />
              Galasakti
              <br />
              <span className="text-gold">Prabowo</span>
            </h1>

            <div className="mt-10 max-w-xl">
              <p className="label">HSE Officer</p>
              <p className="mt-3 font-heading text-xl font-semibold tracking-tight md:text-2xl">
                Available for the next HSE role
              </p>
              <p className="mt-4 text-base leading-relaxed text-btc-muted md:text-lg">
                Oil and gas drilling and large construction since September 2017.
                Last role was HSE Officer on the 1,500 HP PDSI #09.2/N80UE onshore
                rig at PT Pertamina Drilling Services Indonesia, through September 2026.
                Holds AK3 Umum, Operator K3 Migas, Authorized Gas Tester, and First Aider.
                The NEBOSH IGC certificate is not yet issued.
              </p>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <Button
                  onClick={() => setIsModalOpen(true)}
                  className="w-full sm:w-auto"
                >
                  <Download size={16} strokeWidth={2} />
                  Download CV
                </Button>
                <Button
                  href="mailto:wimboro@gmail.com"
                  variant="secondary"
                  className="w-full sm:w-auto"
                >
                  <Mail size={16} strokeWidth={2} />
                  Email me
                </Button>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center lg:col-span-5">
            <div className="relative h-[300px] w-[300px] md:h-[380px] md:w-[380px]">
              <div
                className="absolute inset-0 rounded-full border border-btc-orange/50 animate-[spin_10s_linear_infinite]"
                aria-hidden="true"
              />
              <div
                className="absolute inset-6 rounded-full border border-btc-gold/60 animate-[spin_15s_linear_infinite_reverse]"
                aria-hidden="true"
              />
              <div className="absolute inset-12 overflow-hidden rounded-2xl border border-white/10 bg-black/40 shadow-glow backdrop-blur-lg">
                <img
                  src="/images/profile.jpg"
                  alt="Wimboro Galasakti Prabowo"
                  className="h-full w-full object-cover"
                />
              </div>
            </div>

            <div className="mt-8 grid w-full max-w-sm grid-cols-2 gap-3">
              <div className="rounded-2xl border border-white/10 bg-black/40 p-4 backdrop-blur-lg">
                <p className="label">Location</p>
                <p className="mt-2 font-mono text-sm text-white">Jakarta</p>
              </div>
              <div className="rounded-2xl border border-white/10 bg-black/40 p-4 backdrop-blur-lg">
                <p className="label">Last role</p>
                <p className="mt-2 font-mono text-sm text-white">Sep 2026</p>
              </div>
            </div>

            <a
              href="https://www.linkedin.com/in/wimboro/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-btc-outline mt-4 w-full max-w-sm"
            >
              LinkedIn
            </a>
          </div>
        </div>
      </section>

      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Resume Preview"
        indexLabel="Document"
        actions={
          <Button onClick={handleDownload} className="px-5">
            <Download size={14} strokeWidth={2} />
            PDF
          </Button>
        }
      >
        <iframe
          src="/documents/CV-Wimboro.pdf"
          className="h-96 w-full rounded-lg bg-white"
          title="CV Preview"
        />
      </Modal>
    </>
  );
};

export default Hero;
